/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
factory('ActivityView', ["$log","HumanResourceData","SiteData","DayData","Activity","WorkingPeriodDayHrSrv","ActivitySrv","DayHrSrv","Period","ActivityData",
        function ($log,HumanResourceData,SiteData,DayData,Activity,WorkingPeriodDayHrSrv,ActivitySrv,DayHrSrv,Period,ActivityData){


    var  ActivityView = function (activity)
    {
        //actIndex : activity index inside hrday
        this.actIndex=ActivityData.getIndexOf(activity);//model Index ActivityData
        this.label = null;
        this.period = new Period();//period of activity

        if (activity!==undefined && activity!=null)
            this.loadDataFrom(activity);

    }
    ActivityView.prototype.copyDataTo = function(activity)//
    {
        activity.setPeriod(this.period);
        activity.label = this.label;
    }
    ActivityView.prototype.loadDataFrom = function(activity)//
    {
        if (activity)
        {
            this.label = activity.label;
            this.setPeriod(activity.period);
        }
    }

    ActivityView.prototype.setPeriod = function(period)
    {
        if (period)
        {
            this.period = new Period(period);

        }
    }

    ActivityView.prototype.setPeriodStart = function(start)
    {
        if (!this.period)
        {
            this.period = new Period();
            this.period.setEnd(start);
        }
        this.period.setStart(start)
    }
    ActivityView.prototype.setPeriodDuration = function(duration)
    {
        if (this.period)
        {
            this.period.setDuration(duration)
        }
    }
    ActivityView.prototype.getModel = function()
    {
        if (this.actIndex!=-1)
            return ActivityData.getByIndex(this.actIndex);
        return null;
    }
    ActivityView.prototype.reloadModel = function()
    {
        var activity = this.getModel();
        if (activity)
            this.loadDataFrom(activity);
    }

    return ActivityView;
}])


// WEBPACK FOOTER //
// ./js/services/customerSite/views/ActivityView.js